//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import RegularTitle from '~/components/atoms/Global/RegularTitle.vue';
import SimpleParagraph from '~/components/atoms/Editorial/SimpleParagraph.vue';
export default {
  components: {
    RegularTitle,
    SimpleParagraph
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    title() {
      return {
        text: this.payload.primary.title[0].text || '',
        color: this.payload.primary.title_color || '',
        level: this.payload.primary.title[0].type || ''
      };
    },

    simpleMainParagraph() {
      return this.payload.primary.simple_paragraph_main || [];
    },

    simplePairedParagraph1() {
      return this.payload.primary.simple_paragraph_paired_1 || [];
    },

    simplePairedParagraph2() {
      return this.payload.primary.simple_paragraph_paired_2 || [];
    }

  }
};